import React from 'react';
import { UI_THEME } from '../../config/constants';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  variant?: 'default' | 'soft' | 'strong';
  hover?: boolean;
}

export const GlassCard: React.FC<GlassCardProps> = ({
  children,
  className = '',
  style = {},
  variant = 'default',
  hover = false,
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'soft':
        return {
          background: 'rgba(255, 255, 255, 0.08)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          boxShadow: UI_THEME.shadows.glassSoft,
        };
      case 'strong':
        return {
          background: 'rgba(255, 255, 255, 0.25)',
          backdropFilter: 'blur(16px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          boxShadow: UI_THEME.shadows.glass,
        };
      default:
        return {
          background: UI_THEME.glassmorphism.background,
          backdropFilter: UI_THEME.glassmorphism.backdropFilter,
          border: UI_THEME.glassmorphism.border,
          boxShadow: UI_THEME.glassmorphism.boxShadow,
        };
    }
  };

  const baseStyles: React.CSSProperties = {
    borderRadius: UI_THEME.borderRadius.md,
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    ...getVariantStyles(),
    ...(hover && {
      cursor: 'pointer',
      ':hover': {
        background: UI_THEME.glassmorphism.backgroundHover,
        border: UI_THEME.glassmorphism.borderHover,
        transform: 'translateY(-2px)',
      }
    }),
    ...style,
  };

  return (
    <div 
      className={className}
      style={baseStyles}
      onMouseEnter={(e) => {
        if (hover) {
          e.currentTarget.style.background = UI_THEME.glassmorphism.backgroundHover;
          e.currentTarget.style.border = UI_THEME.glassmorphism.borderHover;
          e.currentTarget.style.transform = 'translateY(-2px)';
        }
      }}
      onMouseLeave={(e) => {
        if (hover) {
          const variantStyles = getVariantStyles();
          e.currentTarget.style.background = variantStyles.background;
          e.currentTarget.style.border = variantStyles.border;
          e.currentTarget.style.transform = 'translateY(0)';
        }
      }}
    >
      {children}
    </div>
  );
};